import "#lib/assert.js";

var assert = new Asserter({ userMessage: "An error occurred initializing the publishing snippet preview." });

jQuery(function () {
  // Under Vite this file is statically imported from admin.js and runs on
  // every admin page. The form partial (`_preview_thumbnail.html.erb`) is
  // only rendered on pages with a preview thumbnail field, so bail out when
  // the settings input isn't present.
  if (!document.getElementById("preview_thumbnail_settings")) {
    return;
  }

  var thumbnailSettingsInput = assert.element("#preview_thumbnail_settings");
  var form = assert.element(thumbnailSettingsInput.closest("form"));
  var titleInput = form.find('[data-behaviour~="alphabetical-index-column-input"]');
  var descriptionInput = form.find("#summary");
  var thumbnailPreviewContainer = assert.element("#thumbnail_preview_container");

  var title = Asserter.exists(titleInput) ? titleInput.val() : false;
  var description = Asserter.exists(descriptionInput) ? descriptionInput.val() : false;
  var autoDetectFace = jQuery("#preview_thumbnail_detect_face").val() === "true";
  var reviewPaneProps = getReviewPaneProps();
  var thumbnailAssetEndpoint = getThumbnailAssetEndpoint(thumbnailSettingsInput, reviewPaneProps);
  var publishingSnippetPreview = new Sparkle.PublishingSnippetPreview(getThumbnailData(), {
    title: title,
    description: description,
    detectFace: autoDetectFace,
    aspectRatio: thumbnailSettingsInput.data("thumbnailCropAspectRatio"),
    libraryEndpoint: thumbnailAssetEndpoint,
    uploadEndpoint: thumbnailAssetEndpoint,
    editable: function () {
      return !thumbnailSettingsInput.prop("disabled");
    },
  });

  // BEHAVIOUR

  jQuery(publishingSnippetPreview).on("update:thumbnail", handleThumbnailUpdate);
  thumbnailSettingsInput.on("review-form:value-set", handleThumbnailSettingsValueSet);

  if (title !== false) {
    titleInput.on("change", handleTitleChange);
  }

  if (description !== false) {
    jQuery(publishingSnippetPreview).on("update:description", handleDescriptionUpdate);
    descriptionInput.on("change", handleDescriptionChange);
  }

  // EVENT HANDLERS

  function handleDescriptionUpdate(_, description) {
    descriptionInput.val(description);
  }

  function handleThumbnailUpdate(_, thumbnailData) {
    recordThumbnailData(thumbnailData);
  }

  function handleThumbnailSettingsValueSet() {
    publishingSnippetPreview.thumbnailData = getThumbnailData();
    publishingSnippetPreview.renderThumbnail();
  }

  function handleTitleChange() {
    publishingSnippetPreview.title = titleInput.val();
    publishingSnippetPreview.renderTitle();
  }

  function handleDescriptionChange() {
    publishingSnippetPreview.description = descriptionInput.val();
    publishingSnippetPreview.renderDescription();
  }

  // INITIALIZE

  thumbnailPreviewContainer.append(publishingSnippetPreview.render().el);

  // HELPER FUNCTIONS

  function getThumbnailData() {
    var json = thumbnailSettingsInput.val() || "{}";
    return JSON.parse(json);
  }

  function getReviewPaneProps() {
    var reviewPane = document.querySelector("#sidebar-item-review");

    if (!reviewPane || !reviewPane.dataset.vueProps) {
      return {};
    }

    return JSON.parse(reviewPane.dataset.vueProps);
  }

  function getThumbnailAssetEndpoint(thumbnailSettingsInput, reviewPaneProps) {
    return (
      thumbnailSettingsInput.data("thumbnailAssetEndpoint") ||
      reviewPaneProps.thumbnailAssetEndpoint ||
      reviewPaneProps.thumbnailAssetLibraryUrl ||
      reviewPaneProps.thumbnailAssetUploadUrl
    );
  }

  function recordThumbnailData(thumbnailData) {
    thumbnailSettingsInput.val(JSON.stringify(thumbnailData));
    thumbnailSettingsInput.trigger("input");
  }
});
